<script lang="ts">
	import { Container, Text, Toggle } from '@Shelly/shelly-design-system';
	import { createEventDispatcher, getContext } from 'svelte';
	import { format } from 'svelte-i18n';

	import BrightnessSlider from '../../Schedules/SchedulesHelpers/BrightnessSlider.svelte';
	import { capFirstChar } from 'src/helpers/utilities';

	export let disabled = false;

	const nightModeStore: SvelteStore<any> = getContext('nightMode');
	const dispatch = createEventDispatcher();

	const hasToggle =
		typeof $nightModeStore?.ct !== 'undefined' && typeof $nightModeStore?.rgb !== 'undefined';

	let brightness = $nightModeStore.brightness || 1;
	let isEnabled =
		typeof $nightModeStore.brightness !== 'undefined' && $nightModeStore.brightness !== null;

	/**
	 * Handles brightness value changes from the brightness slider
	 * Dispatches the new brightness value to the parent component
	 *
	 * @param e - CustomEvent The event object containing the new brightness value in e.detail
	 * @returns void
	 */
	const changeBrightness = (e) => {
		dispatch('update', { brightness: `${e.detail}` });
	};

	/**
	 * Handles the toggle enable/disable state for brightness
	 * When enabling, sets default brightness value to 50
	 * When disabling, sets brightness to null
	 *
	 * @returns void
	 */
	const handleToggle = () => {
		isEnabled = !isEnabled;
		if (isEnabled) {
			brightness = 50;
		} else {
			brightness = null;
		}
		dispatch('update', { brightness });
	};
</script>

{#if hasToggle}
	<Toggle id="toggle-khjuawy" bind:checked={isEnabled} size="m" class="mb-s" on:click={handleToggle}>
		{$format('label_enable')}
	</Toggle>
{/if}
<Container class="mb-s" padding="0">
	<Text element="h2" class="mb-s">
		{$format('select_type', {
			values: { type: $format('label_brightness') },
		})}
	</Text>
	<BrightnessSlider
		disabled={disabled || !isEnabled}
		min={$nightModeStore.min}
		title={capFirstChar($format('collapse_title_brightness'))}
		value={brightness || 1}
		on:change={changeBrightness}
	/>
</Container>
